import { render, staticRenderFns } from "./LandingWishlistFR-V2.vue?vue&type=template&id=67db3f6b&scoped=true"
import script from "./LandingWishlistFR-V2.vue?vue&type=script&lang=js"
export * from "./LandingWishlistFR-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db3f6b",
  null
  
)

export default component.exports